// extracted by mini-css-extract-plugin
export default {"info":"styles-module__info__src-labstep-web-components-Resource-Info-Preview-_LjBwU","image":"styles-module__image__src-labstep-web-components-Resource-Info-Preview-_qkMHu"};